/** @format */

export default {
  setMedicalLettersRequests(state, payload) {
    state.medicalLetterRequests = payload;
  },
  setMedicalLetterRequest(state, payload) {
    state.medicalLetterRequest = payload;
  },
  setMedicalLetterRequestQuestions(state, payload) {
    state.medicalLetterRequestQuestions = payload.data;
  },
  setSignature(state, payload) {
    state.signature = payload;
  },
  updateSignature(state, payload) {
    state.signature = [payload, ...state.signature];
  },
  editSignature(state, payload) {
    state.signature.splice(payload.signatureId, 1, payload.response);
  },
  setDoctorsProfile(state, payload) {
    state.doctorsProfile = payload;
  },
  setDoctorProfile(state, payload) {
    state.doctorProfile = payload;
  },

  setDoctor(state, payload) {
    state.doctor = payload;
  },
  setAlternativeDoctors(state, payload) {
    state.alternativeDoctor = payload?.data;
  },

  updateDoctorGmcStatus(state, doctorId) {
    if (state.doctorsProfile?.data?.data) {
      state.doctorsProfile.data.data = state.doctorsProfile.data.data.filter(
        (doc) => doc.id !== doctorId
      );
      if (state.doctorsProfile.data.total) {
        state.doctorsProfile.data.total--;
      }
    }
    if (state.doctorProfile?.id === doctorId) {
      state.doctorProfile = null;
    }
  },

  setEmailError(state, payload) {
    state.emailError = payload;
  },
  setPractices(state, payload) {
    state.practices = payload;
  },
};
